import React, { useCallback, useState } from "react";
import { Input, Button, Typography } from "@mui/material";
import { useDropzone } from "react-dropzone";
import { CloudUpload } from "@mui/icons-material";

import DriveFolderUploadRoundedIcon from "@mui/icons-material/DriveFolderUploadRounded";
import CheckCircle from "@mui/icons-material/CheckCircle";

export default function Upload({ onUploadClick }) {
    const onDrop = useCallback((acceptedFiles) => {
        console.log(acceptedFiles[0]);
        setFile(acceptedFiles[0]);
        setFilename(acceptedFiles[0].name);
    }, []);

    const [file, setFile] = useState(null);
    const [filename, setFilename] = useState(null);
    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
    });

    return (
        <div className="Upload">
            <div
                style={{
                    backgroundColor: isDragActive ? "#f1f8e9" : "#EEEEEE",
                }}
                className="Dropzone"
                {...getRootProps()}
            >
                <Input id="dropzone" type="file" {...getInputProps()} />
                <div className="SelectedFile">
                    {filename ? (
                        <CheckCircle
                            sx={{ width: 100, height: 100 }}
                            color="primary"
                        />
                    ) : (
                        <DriveFolderUploadRoundedIcon
                            sx={{ width: 100, height: 100 }}
                            color="action"
                        />
                    )}
                    <Typography>
                        {filename ? filename : "No File Selected"}
                    </Typography>
                </div>
                {isDragActive ? (
                    <Typography>Drop Your File Here</Typography>
                ) : (
                    <div className="DropzoneHint">
                        <Typography variant="h5">
                            Select Your Raman Spectroscopy Result
                        </Typography>
                        <Typography variant="subtitle1">
                            Drag and Drop the .csv File or Click to Select
                        </Typography>
                    </div>
                )}
            </div>
            <Button
                sx={{ borderRadius: "1.5rem" }}
                fullWidth
                variant="contained"
                component="span"
                className="UploadButton"
                size="large"
                startIcon={<CloudUpload />}
                onClick={() => onUploadClick(file)}
            >
                Upload File for Analysis
            </Button>
        </div>
    );
}
